export default {
  /**
   * Set state of loading at refresh profile previews
   * @param {boolean} payload - Value (default: false)
   */
  setProfilePreviewsLoading(state, payload = false) {
    state.profilePreviewsLoading = payload
  },
  /**
   * Set state of profile previews
   * @param {{ firstName: string, lastName: string, fullName: string, nick: string, isActive: boolean, processingMedia: boolean, thumbnailUrl: string, [key: string]: any }[]} payload as array of objects returned from backend.
   */
  setProfilePreviews(state, payload) {
    const oldProfilePreviews = state.profilePreviews.filter(
      oldProfilePreview => {
        const elementExists = !!payload.find(
          newProfilePreview =>
            (newProfilePreview.profileId &&
              oldProfilePreview.profileId === newProfilePreview.profileId) ||
            (newProfilePreview.uuid &&
              oldProfilePreview.uuid === newProfilePreview.uuid),
        )
        return !elementExists
      },
    )
    state.profilePreviews = [...oldProfilePreviews, ...payload]
  },
  /**
   * Set state of profile previews queue (refresh queue)
   * @param {({ profileId: number, uuid?:string } | { profileId?: number, uuid:string })[]} payload as array of objects with props: uuid and profileId (one of them required)
   * @param {number | undefined | null} queryItems[].profileId - ProfileId of user to refresh
   * @param {number | undefined | null} queryItems[].uuid - Uuid of user to refresh
   */
  setProfilePreviewsQueue(state, payload) {
    state.profilePreviewsQueue = [...payload]
  },
  /**
   * Clear state of profile previews queue (refresh queue) - sets to empty array
   */
  clearProfilePreviews(state) {
    state.profilePreviews = []
  },
  /**
   * Add items to existing state of profile previews queue (refresh queue)
   * @param {({ profileId: number, uuid?:string } | { profileId?: number, uuid:string })[]} payload as array of objects with props: uuid and profileId (one of them required)
   * @param {number | undefined | null} queryItems[].profileId - ProfileId of user to refresh
   * @param {number | undefined | null} queryItems[].uuid - Uuid of user to refresh
   */
  addProfilePreviewsQueue(state, payload) {
    const profilePreviewsQueueToAdd = payload.filter(newQueueItem => {
      const queueItemExists = !!state.profilePreviewsQueue.find(
        currentQueueItem =>
          (newQueueItem.profileId &&
            newQueueItem.profileId === currentQueueItem.profileId) ||
          (newQueueItem.uuid && newQueueItem.uuid === currentQueueItem.uuid),
      )
      return !queueItemExists
    })

    state.profilePreviewsQueue = [
      ...state.profilePreviewsQueue,
      ...profilePreviewsQueueToAdd
    ]
  }
}
